import { render, staticRenderFns } from "./NfeCard.vue?vue&type=template&id=0a4baab6&scoped=true"
import script from "./NfeCard.vue?vue&type=script&lang=js"
export * from "./NfeCard.vue?vue&type=script&lang=js"
import style0 from "./NfeCard.vue?vue&type=style&index=0&id=0a4baab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4baab6",
  null
  
)

export default component.exports